var _ellipse, _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInferiorDireita(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 60,
    rx: 40,
    ry: 25,
    fill: "#fff",
    stroke: "#1976d2",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 45,
    width: 30,
    height: 30,
    fill: "#90caf9",
    opacity: 0.7
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 85,
    fontSize: 12,
    textAnchor: "middle",
    fill: "#1976d2"
  }, "Inferior Direita")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInferiorDireita);
export default __webpack_public_path__ + "static/media/inferior-direita.5574064697c6ac917235259a698d0f16.svg";
export { ForwardRef as ReactComponent };